import { render, staticRenderFns } from "./SimulationDetailSinglePlots.vue?vue&type=template&id=53a4b343"
import script from "./SimulationDetailSinglePlots.vue?vue&type=script&lang=ts"
export * from "./SimulationDetailSinglePlots.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports